export const MOP_TYPES = {
  STRING_MOP: "String mop",
  MICRO_FIBRE_FLAT_MOP: "Micro fibre flat mop",
  IMOPLITE: "i-mop lite",
  IMOPXL: "i-mop XL",
  IMOPXXL: "i-mop XXL",
};

export const CURRENCIES = {
  USD: { label: "USD", symbol: "$" },
  EUR: { label: "EUR", symbol: "€" },
  GBP: { label: "GBP", symbol: "£" },
  AUD: { label: "AUD", symbol: "$" },
  JPY: { label: "JPY", symbol: "¥" },
  NZD: { label: "NZD", symbol: "$" },
  HUF: { label: "HUF", symbol: "ft" },
  PLN: { label: "PLN", symbol: "zł" },
  CZK: { label: "CZK", symbol: "Kč" },
  DKK: { label: "DKK", symbol: "kr" },
  NOK: { label: "NOK", symbol: "kr" },
  SEK: { label: "SEK", symbol: "kr" },
};

export const SURFACE_UNITS = {
  m2: { label: "m²", conversionRatio: 1, maxSurface: 5000 },
  ft2: { label: "ft²", conversionRatio: 10.7639, maxSurface: 50000 },
};

export const LANGUAGES = {
  cz: { flag: "🇨🇿", currencies: [CURRENCIES.CZK] },
  dk: { flag: "🇩🇰", currencies: [CURRENCIES.DKK] },
  de: { flag: "🇩🇪", currencies: [CURRENCIES.EUR] },
  en: {
    flag: "🇬🇧",
    currencies: [
      CURRENCIES.USD,
      CURRENCIES.GBP,
      CURRENCIES.EUR,
      CURRENCIES.AUD,
      CURRENCIES.NZD,
    ],
  },
  es: { flag: "🇪🇸", currencies: [CURRENCIES.EUR] },
  fi: { flag: "🇫🇮", currencies: [CURRENCIES.EUR] },
  fr: { flag: "🇫🇷", currencies: [CURRENCIES.EUR] },
  hu: { flag: "🇭🇺", currencies: [CURRENCIES.HUF] },
  it: { flag: "🇮🇹", currencies: [CURRENCIES.EUR] },
  jp: { flag: "🇯🇵", currencies: [CURRENCIES.JPY] },
  nl: { flag: "🇳🇱", currencies: [CURRENCIES.EUR] },
  no: { flag: "🇳🇴", currencies: [CURRENCIES.NOK] },
  pl: { flag: "🇵🇱", currencies: [CURRENCIES.PLN] },
  pt: { flag: "🇵🇹", currencies: [CURRENCIES.EUR] },
  sw: { flag: "🇸🇪", currencies: [CURRENCIES.SEK] },
};
